import fly from './fly'
import { getAuth } from '@/util/storage'
const auth = getAuth()

export const fetchDefaultDepot = (params: Object) =>
  fly.get('/mall/cs/depot/defaultDepot.json', { ...params, auth })

export const fetchDepotList = (params: Object) =>
  fly.get('/mall/cs/depot/list.json', { ...params, auth }).then(res => res.data)
